const LocationComponent = () => import('@/views/WareHouse/Location/LocationView')

export default [
    {
        path:'/LocationIndex',
        name:'LocationComponent',
        component:LocationComponent
    }
]